import {
  colors,
  ImpCard,
  ImpCardThumbnail,
  ImpFlex,
  ImpSpacer,
  ImpText,
} from '@imprint-payments/imprint-ui';

import { EVENT } from '../../analytics/analyticsConsts';
import { useImpState } from '../../app/hooks';
import {
  CardDesignOption,
  CardDesignStatus,
} from '../../app/merchantDataSlice';
import { FORM_BUTTON_WIDTH } from '../../assets/consts/const';
import { ANALYTICS } from '../../firebase/firebase';
import { convertAmountToString } from '../../utils/functionUtils';
import styles from './CardDesignPicker.module.css';

export interface CardDesignDisplay extends CardDesignOption {
  imgSrc: string;
}

interface CardDesignPickerProps {
  cardDesigns: CardDesignDisplay[];
  selectedID: string;
  setSelectedID: (id: string) => void;
}

export default function CardDesignPicker({
  cardDesigns,
  selectedID,
  setSelectedID,
}: CardDesignPickerProps) {
  const { language } = useImpState();
  const selectedCard = cardDesigns.find(
    (design) => design.cardDesignID === selectedID
  )!;
  const selectedImgSrc = selectedCard.imgSrc;

  return (
    <>
      <div className={styles.cardContainer}>
        <ImpCard src={selectedImgSrc} width={FORM_BUTTON_WIDTH} />
        {selectedCard?.status === CardDesignStatus.NOT_SELECTABLE && (
          <>
            <div className={styles.outOfStockOverlay} />
            <div className={styles.outOfStockBadge}>
              <ImpText
                typography="label1"
                color={colors.content.onSurfaceDisabled}
              >
                {selectedCard.reason}
              </ImpText>
            </div>
          </>
        )}
      </div>
      <ImpSpacer height="l" />
      <ImpText typography="label1">{selectedCard.title}</ImpText>
      <ImpText typography="body2" color={colors.content.onSurfaceVariant}>
        {selectedCard.fee
          ? convertAmountToString(selectedCard.fee)
          : language.free}
      </ImpText>
      <ImpSpacer height="xl" />
      <ImpFlex direction="row" gap="xs" flexWrap justify="center">
        {cardDesigns
          .filter(
            (cardDesign) =>
              cardDesign.status === CardDesignStatus.SELECTABLE ||
              cardDesign.status === CardDesignStatus.NOT_SELECTABLE
          )
          .map((cardDesign, index) => (
            <ImpCardThumbnail
              id={`card-thumbnail-${index}`}
              key={index}
              isSelected={selectedID === cardDesign.cardDesignID}
              src={cardDesign.imgSrc}
              onClick={() => {
                ANALYTICS.logEvent(EVENT.CARD_ART_SELECTION_CHANGED, {
                  card_status: cardDesign.status,
                  card_design_id: cardDesign.cardDesignID,
                });
                setSelectedID(cardDesign.cardDesignID);
              }}
            />
          ))}
      </ImpFlex>
    </>
  );
}
